import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBranchDropdown, IBranchState } from '../../../types/branches/branchInterfaces';

export const initialState: IBranchState = {
  branchDropdown: [],
  myBranch: null,
};

export const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    loadingBranchDropdown: (state, action: PayloadAction<IBranchDropdown[]>) => {
      state.branchDropdown = action.payload;
    },
    loadingMyBranch: (state, action: PayloadAction<IBranchDropdown | null>) => {
      state.myBranch = action.payload;
    },
    // Mismo motivo que resetSidebarState/clearRoles: es estado por usuario,
    // hay que limpiarlo al salir para que el siguiente login (SPA, sin F5)
    // no herede la sucursal del usuario anterior en memoria.
    resetBranchState: () => initialState,
  },
});

export const { loadingBranchDropdown, loadingMyBranch, resetBranchState } = branchSlice.actions;

export default branchSlice.reducer;
